const BASE_URL = "https://localhost:8080"

const env = {
    BASE_URL: BASE_URL,
}

export default env;